import { useMemo } from 'react'

/**
 * Возвращает список причин увольнения для полей ввода:
 * - скрывает родителей (parentId === null), если у них есть дети
 * - оставляет родителей без детей
 * - всегда оставляет дочерние элементы (parentId != null)
 */
export function useTerminationReasonsForInputs(terminationReasons) {
	return useMemo(() => {
		if (!Array.isArray(terminationReasons)) return []

		const parentIdsWithChildren = new Set(
			terminationReasons.map((item) => item?.parentId).filter((parentId) => parentId != null)
		)

		return terminationReasons.filter((item) => item?.parentId != null || !parentIdsWithChildren.has(item?.id))
	}, [terminationReasons])
}
